import { Request } from '../request';

export const getVerifiedPlusStatus = () => Request.get({ url: '/schedule-server/provider/verified-plus/status' });

export const joinVerifiedPlus = (data: { agreementAccepted: boolean; agreementVersion?: string }) => Request.post({ url: '/schedule-server/provider/verified-plus/join', params: data });

export const leaveVerifiedPlus = () => Request.post({ url: '/schedule-server/provider/verified-plus/leave' });
